// ** React Imports
import { Fragment, useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// ** Third Party Components
import classnames from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";

// ** Vertical Menu Components
import NavbarHeader from "../header/NavbarHeader";
import VerticalNavMenuItems from "../../../@core/layouts/components/menu/vertical-menu/VerticalNavMenuItems";

import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Progress,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Package,
  Video,
  Users,
  ChevronRight,
  Edit,
  Bell,
  Power,
  Settings,
} from "react-feather";
import themeConfig from "@configs/themeConfig";
import "./style.scss";
import { fetchNavbarStats } from "./navbarStatsActions";
import { addDefaultSrc } from "../../../utilities";
import NavSelectBrand from "./SwitchBrand/NavSelectBrand";
import Cookies from "js-cookie";
import { usePrevious } from "../../../Shared/CustomHooks";
import { isEmpty } from "lodash";
// import PubNub from "../../../Pages/Chat/pubnub_container";
import { isUserLoggedIn } from "@utils";
import { handleLogout } from "@store/authentication";
import { LOGOUT } from "../../../Entry/session_actions";
import { gql, useQuery } from "@apollo/client";
import ReleaseVersion from "../../../Shared/PopUpModals/ReleaseVersion/ReleaseVersion";

const MY_QUERY = gql`
  query MyQuery {
    getFrontEndAppVersion {
      id
      name
      projectId
      released
      releaseDate
      startDate
      userStartDate
      userReleaseDate
      description
      archived
    }
  }
`;

const getPicture = (brandImage) => {
  const { profile_photo: profilePhoto } = brandImage || {};
  const { url } = profilePhoto || {};
  return url;
};

const Sidebar = (props) => {
  // ** Props
  const { menuCollapsed, menu, skin, menuData } = props;
  const navbarStatsReducer = useSelector((state) => state.navbarStatsReducer);
  const selectedBrandReducer = useSelector(
    (state) => state.selectedBrandReducer
  );
  const { brand_id } = selectedBrandReducer;
  const dispatch = useDispatch();

  // ** States
  const [groupOpen, setGroupOpen] = useState([]);
  const [groupActive, setGroupActive] = useState([]);
  const [currentActiveGroup, setCurrentActiveGroup] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [anchorEl, setAnchorEl] = useState(false);
  // ** Menu Hover State
  const [menuHover, setMenuHover] = useState(false);
  const prevBrand_id = usePrevious(brand_id);
  const [userData, setUserData] = useState({});
  const [releaseModal, setReleaseModal] = useState(false);
  const navigate = useNavigate();

  // ** Ref
  const shadowRef = useRef(null);
  const { loading: versionLoading, error, data } = useQuery(MY_QUERY);

  useEffect(() => {
    if (Cookies.get("bId")) {
      dispatch(fetchNavbarStats());
    }

    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem("session")));
    }
  }, []);

  useEffect(() => {
    if (prevBrand_id) {
      if (prevBrand_id !== brand_id) {
        dispatch(fetchNavbarStats());
      }
    }
  }, [brand_id]);

  // ** Function to handle Mouse Enter
  const onMouseEnter = () => {
    setMenuHover(true);
  };

  // ** Scroll Menu
  // const scrollMenu = (container) => {
  //   if (shadowRef && container.scrollTop > 0) {
  //     if (!shadowRef.current.classList.contains("d-block")) {
  //       shadowRef.current.classList.add("d-block");
  //     }
  //   } else {
  //     if (shadowRef.current.classList.contains("d-block")) {
  //       shadowRef.current.classList.remove("d-block");
  //     }
  //   }
  // };

  const progressCircle = {
    height: "9px",
    width: "9px",
    borderRadius: "50%",
    display: "inline-block",
    margin: "2px",
  };

  const inActiveProgressCircle = {
    ...progressCircle,
    backgroundColor: "#bbb",
  };
  const activeProgressCircle = {
    ...progressCircle,
    backgroundColor: "#6fd1c7",
  };

  const { currentUser } = userData;

  const toggleDropDown = () => {
    setAnchorEl(!anchorEl);
  };

  const clearAll = () => {
    dispatch(handleLogout());
    dispatch({ type: LOGOUT });
    navigate("/login");
  };

  const dropDownMenu = (
    <div
      className="position-absolute"
      style={{
        background: "white",
        width: "130px",
        padding: "5px 13px",
        boxShadow: "0 5px 25px rgba(34,41,47,.1)",
        left: 20,
        bottom: 0,
      }}
    >
      <div
        className="d-flex p-1 ps-0 gap-1 align-items-center"
        role="button"
        onClick={() => {
          navigate("/account-settings");
        }}
      >
        <Settings size={14} className="me-75" />
        <span className="align-middle">Settings</span>
      </div>
      <div
        className="d-flex p-1 ps-0 pt-0 gap-1 align-items-center"
        role="button"
        onClick={() => {
          navigate("/support");
        }}
      >
        <img
          width={14}
          className="me-75"
          src={require("@src/assets/images/vyrill/icons/support.png").default}
        />
        <span className="align-middle">Support</span>
      </div>

      <div
        className="p-1 pt-0 ps-0 d-flex gap-1 align-items-center"
        role="button"
        onClick={() => {
          clearAll();
        }}
      >
        <Power size={14} className="me-75" />
        <span className="align-middle">Logout</span>
      </div>
    </div>
  );

  return (
    <Fragment>
      <div
        className={classnames(
          "main-menu menu-fixed menu-accordion menu-shadow",
          {
            expanded: menuHover || menuCollapsed === false,
            "menu-light": skin !== "semi-dark" && skin !== "dark",
            "menu-dark": skin === "semi-dark" || skin === "dark",
          }
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={() => {
          setMenuHover(false), setAnchorEl(false);
        }}
        // style={{ marginTop: '74px' }}
      >
        {menu ? (
          menu({ ...props })
        ) : (
          <Fragment>
            {/* Vertical Menu Header */}
            {/* <NavbarHeader
              setGroupOpen={setGroupOpen}
              menuHover={menuHover}
              {...props}
            /> */}
            {/* Vertical Menu Header Shadow */}
            {/* <div ref={shadowRef}></div> */}
            {/* Perfect Scrollbar */}

            <div
              className="ps-1 pe-1"
              style={{
                marginTop: "23px",
                marginBottom: menuHover ? "0px" : "20px",
              }}
            >
              <div className="flex-direction-column">
                <div
                  role="button"
                  className="text-center"
                  onClick={() => navigate("/home")}
                >
                  <img
                    className={`${
                      menuHover ? "brand-image" : "brand-image-menuHover"
                    }`}
                    width={100}
                    src={
                      (navbarStatsReducer &&
                        getPicture(navbarStatsReducer?.brandPicture)) ||
                      require("@src/assets/images/vyrill/default.png").default
                    }
                    onError={(event) => addDefaultSrc(event)}
                  />
                </div>

                {/* ) : (
                  // onHover brand Image
                  <div className="text-center">
                    <img
                      className="brand-image-menuHover"
                      width={100}
                      src={
                        (navbarStatsReducer &&
                          getPicture(navbarStatsReducer.brandPicture)) ||
                        require("@src/assets/images/vyrill/default.png").default
                      }
                      onError={(event) => addDefaultSrc(event)}
                    />
                  </div>
                )} */}
                {/* <div className="text-center">
                  <img
                    className="brand-image"
                    width={100}
                    src={
                      (navbarStatsReducer &&
                        getPicture(navbarStatsReducer.brandPicture)) ||
                      require("@src/assets/images/vyrill/default.png").default
                    }
                    onError={(event) => addDefaultSrc(event)}
                    onClick={() => navigate("/home")}
                    role="button"
                  />
                </div> */}
                {/* <div className="d-flex justify-content-center">
                  <h4
                    className="mt-2 mb-2 text-center"
                    style={
                      !isEmpty(navbarStatsReducer.currentBrand) &&
                      navbarStatsReducer.currentBrand.name.length > 14
                        ? { width: "121px", lineBreak: "anywhere" }
                        : {}
                    }
                  >
                    <strong>
                      {navbarStatsReducer.currentBrand.name
                        ? navbarStatsReducer.currentBrand.name.replace(
                            /_/g,
                            " "
                          )
                        : ""}
                    </strong>
                  </h4>
                </div> */}
              </div>

              {/* <div className="d-flex">
                <div className="col-4 p-0 flex-direction-column text-center">
                  <div>
                    <span>
                      {(navbarStatsReducer &&
                        navbarStatsReducer.counts.products) ||
                        0}
                    </span>
                  </div>

                  <div>Products</div>
                </div>
                <div className="col-4 p-0 flex-direction-column text-center">
                  {" "}
                  <div>
                    <span>
                      {(navbarStatsReducer &&
                        navbarStatsReducer.counts.videos) ||
                        0}
                    </span>
                  </div>
                  <div>Videos</div>
                </div>
                <div className="col-4 p-0 flex-direction-column text-center">
                  {" "}
                  <div>
                    <span>
                      {(navbarStatsReducer &&
                        navbarStatsReducer.counts.influencers) ||
                        0}
                    </span>
                  </div>
                  <div>Creators</div>
                </div>
              </div> */}
            </div>

            <div className={menuHover ? "" : "hidden"}>
              {navbarStatsReducer.roles.includes("digital_agency") && (
                <NavSelectBrand brands={navbarStatsReducer.brands} />
              )}
            </div>

            <PerfectScrollbar
            // className="main-menu-content"
            // options={{ wheelPropagation: false }}
            // onScrollY={(container) => scrollMenu(container)}
            // style={{ maxHeight: "calc((65vh - 20px) - 30px)" }}
            // style={{
            //   maxHeight: `${
            //     navbarStatsReducer &&
            //     navbarStatsReducer.roles.includes("digital_agency")
            //       ? "69vh"
            //       : "69vh"
            //   }`,
            // }}
            >
              <ul
                className={`navigation
                 `}
                style={
                  menuHover
                    ? { marginTop: "10px" }
                    : { width: "80px", marginLeft: "7px", marginTop: "10px" }
                }
              >
                <VerticalNavMenuItems
                  items={menuData}
                  menuData={menuData}
                  menuHover={menuHover}
                  groupOpen={groupOpen}
                  activeItem={activeItem}
                  groupActive={groupActive}
                  setGroupOpen={setGroupOpen}
                  menuCollapsed={menuCollapsed}
                  setActiveItem={setActiveItem}
                  setGroupActive={setGroupActive}
                  currentActiveGroup={currentActiveGroup}
                  setCurrentActiveGroup={setCurrentActiveGroup}
                />
              </ul>
            </PerfectScrollbar>
          </Fragment>
        )}
        {/* {menuHover ? "-50px" : "0"} */}
        <div
          style={{
            // marginTop: `${menuHover ? "0" : "150"}`,
            listStyle: "none",
            flexDirection: "column",
            alignItems: "center",
            gap: "45px",
            position: "absolute",
            bottom: "69px",
            left: "30%",
            background: "white",
          }}
          className="d-flex"
        >
          <Bell color="#6B727A" size={21} />
          <div
            onClick={toggleDropDown}
            role="button"
            className="text-uppercase default-profile-image"
          >
            {currentUser &&
              currentUser?.first_name?.charAt(0) +
                currentUser?.last_name?.charAt(0)}
          </div>
          {anchorEl && dropDownMenu}
        </div>
        {menuHover && (
          <div
            style={{
              fontSize: "12px",
              position: "absolute",
              left: "29%",
              bottom: "20px",
              cursor: "pointer",
            }}
            onClick={() => setReleaseModal(!releaseModal)}
          >
            v {versionLoading ? "Loading" : data?.getFrontEndAppVersion?.name}
          </div>
        )}
      </div>
      <ReleaseVersion
        data={data?.getFrontEndAppVersion}
        setReleaseModal={setReleaseModal}
        releaseModal={releaseModal}
      />
    </Fragment>
  );
};

export default Sidebar;
